import { textCenter, textJustified, textLeft, textRight } from 'assets/icons'
import { DEFAULT_PICKER_COLORS } from 'components/ColorPickerWithActions/consts'

import translations from './text-toolbar.i18n'

export const FONT_FAMILY_OPTIONS = [
  { value: 'Muli', label: 'Muli' },
  { value: 'Arial', label: 'Arial' },
  { value: 'Courier New', label: 'Courier' },
  { value: 'Georgia', label: 'Georgia' },
  { value: 'Times New Roman', label: 'Times New Roman' },
  { value: 'Verdana', label: 'Verdana' },
]

export const FONT_SIZE_OPTIONS = [
  { value: '8px', label: '8px' },
  { value: '10px', label: '10px' },
  { value: '12px', label: '12px' },
  { value: '14px', label: '14px' },
  { value: '16px', label: '16px' },
  { value: '18px', label: '18px' },
  { value: '24px', label: '24px' },
  { value: '30px', label: '30px' },
  { value: '36px', label: '36px' },
  { value: '48px', label: '48px' },
  { value: '60px', label: '60px' },
  { value: '72px', label: '72px' },
  { value: '86px', label: '86px' },
]

export const ALIGN_OPTIONS = [
  { value: 'left', icon: textLeft, title: translations.alignLeft },
  { value: 'center', icon: textCenter, title: translations.alignCenter },
  { value: 'right', icon: textRight, title: translations.alignRight },
  { value: 'justify', icon: textJustified, title: translations.alignJustify },
]

export const AVAILABLE_HIGHLIGHT_COLORS = [...DEFAULT_PICKER_COLORS, 'transparent']
